// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.IconButton {
    font-family: inherit;
    height: 35px;
    width: 35px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: black;
    outline: none;
}

.IconButton:hover {
    background-color: var(--violet-3);
}

.DropdownMenuContent {
    min-width: 220px;
    background-color: white;
    border-radius: 6px;
    padding: 5px;
    box-shadow:
            0px 10px 38px -10px rgba(22, 23, 24, 0.35),
            0px 10px 20px -15px rgba(22, 23, 24, 0.2);
}

.DropdownMenuItem,
.DropdownMenuCheckboxItem,
.DropdownMenuRadioItem,
.DropdownMenuSubTrigger {
    font-size: 18px;
    line-height: 1;
    color: black;
    border-radius: 3px;
    display: flex;
    align-items: center;
    height: 45px;
    padding: 0 5px;
    position: relative;
    padding-left: 25px;
    -webkit-user-select: none;
            user-select: none;
    outline: none;
    cursor: pointer;
}

.DropdownMenuItem[data-highlighted],
.DropdownMenuCheckboxItem[data-highlighted],
.DropdownMenuRadioItem[data-highlighted],
.DropdownMenuSubTrigger[data-highlighted] {
    background-color: var(--gray-4);
    color: black;
}

.DropdownMenuLabel {
    padding-left: 25px;
    font-size: 12px;
    line-height: 25px;
    color: var(--mauve-11);
}

.AlertDialogOverlay {
    background-color: var(--black-a9);
    position: fixed;
    inset: 0;
    animation: overlayShow 150ms cubic-bezier(0.16, 1, 0.3, 1);
}

.AlertDialogContent {
    background-color: white;
    border-radius: 6px;
    box-shadow:
            hsl(206 22% 7% / 35%) 0px 10px 38px -10px,
            hsl(206 22% 7% / 20%) 0px 10px 20px -15px;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 90vw;
    max-width: 500px;
    max-height: 85vh;
    padding: 25px;
    animation: contentShow 150ms cubic-bezier(0.16, 1, 0.3, 1);
}
.AlertDialogContent:focus {
    outline: none;
}

.AlertDialogTitle {
    margin: 0;
    color: var(--mauve-12);
    font-size: 17px;
    font-weight: 500;
}

.AlertDialogDescription {
    margin-bottom: 20px;
    color: var(--mauve-11);
    font-size: 15px;
    line-height: 1.5;
}

.Button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    padding: 0 15px;
    font-size: 15px;
    line-height: 1;
    font-weight: 500;
    height: 35px;
}
.Button.violet {
    background-color: white;
    color: var(--violet-11);
    box-shadow: 0 2px 10px var(--black-a7);
}
.Button.violet:hover {
    background-color: var(--mauve-3);
}
.Button.violet:focus {
    box-shadow: 0 0 0 2px black;
}
.Button.red {
    background-color: var(--red-4);
    color: var(--red-11);
}
.Button.red:hover {
    background-color: var(--red-5);
}
.Button.red:focus {
    box-shadow: 0 0 0 2px var(--red-7);
}
.Button.mauve {
    background-color: var(--mauve-4);
    color: var(--mauve-11);
}
.Button.mauve:hover {
    background-color: var(--mauve-5);
}
.Button.mauve:focus {
    box-shadow: 0 0 0 2px var(--mauve-7);
}

@keyframes overlayShow {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}

@keyframes contentShow {
    from {
        opacity: 0;
        transform: translate(-50%, -48%) scale(0.96);
    }
    to {
        opacity: 1;
        transform: translate(-50%, -50%) scale(1);
    }
}
`, "",{"version":3,"sources":["webpack://./src/layout/header/Header.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;IACpB,YAAY;IACZ,WAAW;IACX,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,kBAAkB;IAClB,YAAY;IACZ;;qDAEiD;AACrD;;AAEA;;;;IAII,eAAe;IACf,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,yBAAiB;YAAjB,iBAAiB;IACjB,aAAa;IACb,eAAe;AACnB;;AAEA;;;;IAII,+BAA+B;IAC/B,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;IACjC,eAAe;IACf,QAAQ;IACR,0DAA0D;AAC9D;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB;;qDAEiD;IACjD,eAAe;IACf,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,0DAA0D;AAC9D;AACA;IACI,aAAa;AACjB;;AAEA;IACI,SAAS;IACT,sBAAsB;IACtB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,YAAY;AAChB;AACA;IACI,uBAAuB;IACvB,uBAAuB;IACvB,sCAAsC;AAC1C;AACA;IACI,gCAAgC;AACpC;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,8BAA8B;IAC9B,oBAAoB;AACxB;AACA;IACI,8BAA8B;AAClC;AACA;IACI,kCAAkC;AACtC;AACA;IACI,gCAAgC;IAChC,sBAAsB;AAC1B;AACA;IACI,gCAAgC;AACpC;AACA;IACI,oCAAoC;AACxC;;AAEA;IACI;QACI,UAAU;IACd;IACA;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,UAAU;QACV,4CAA4C;IAChD;IACA;QACI,UAAU;QACV,yCAAyC;IAC7C;AACJ","sourcesContent":[".IconButton {\n    font-family: inherit;\n    height: 35px;\n    width: 35px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    color: black;\n    outline: none;\n}\n\n.IconButton:hover {\n    background-color: var(--violet-3);\n}\n\n.DropdownMenuContent {\n    min-width: 220px;\n    background-color: white;\n    border-radius: 6px;\n    padding: 5px;\n    box-shadow:\n            0px 10px 38px -10px rgba(22, 23, 24, 0.35),\n            0px 10px 20px -15px rgba(22, 23, 24, 0.2);\n}\n\n.DropdownMenuItem,\n.DropdownMenuCheckboxItem,\n.DropdownMenuRadioItem,\n.DropdownMenuSubTrigger {\n    font-size: 18px;\n    line-height: 1;\n    color: black;\n    border-radius: 3px;\n    display: flex;\n    align-items: center;\n    height: 45px;\n    padding: 0 5px;\n    position: relative;\n    padding-left: 25px;\n    user-select: none;\n    outline: none;\n    cursor: pointer;\n}\n\n.DropdownMenuItem[data-highlighted],\n.DropdownMenuCheckboxItem[data-highlighted],\n.DropdownMenuRadioItem[data-highlighted],\n.DropdownMenuSubTrigger[data-highlighted] {\n    background-color: var(--gray-4);\n    color: black;\n}\n\n.DropdownMenuLabel {\n    padding-left: 25px;\n    font-size: 12px;\n    line-height: 25px;\n    color: var(--mauve-11);\n}\n\n.AlertDialogOverlay {\n    background-color: var(--black-a9);\n    position: fixed;\n    inset: 0;\n    animation: overlayShow 150ms cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.AlertDialogContent {\n    background-color: white;\n    border-radius: 6px;\n    box-shadow:\n            hsl(206 22% 7% / 35%) 0px 10px 38px -10px,\n            hsl(206 22% 7% / 20%) 0px 10px 20px -15px;\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: 90vw;\n    max-width: 500px;\n    max-height: 85vh;\n    padding: 25px;\n    animation: contentShow 150ms cubic-bezier(0.16, 1, 0.3, 1);\n}\n.AlertDialogContent:focus {\n    outline: none;\n}\n\n.AlertDialogTitle {\n    margin: 0;\n    color: var(--mauve-12);\n    font-size: 17px;\n    font-weight: 500;\n}\n\n.AlertDialogDescription {\n    margin-bottom: 20px;\n    color: var(--mauve-11);\n    font-size: 15px;\n    line-height: 1.5;\n}\n\n.Button {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 4px;\n    padding: 0 15px;\n    font-size: 15px;\n    line-height: 1;\n    font-weight: 500;\n    height: 35px;\n}\n.Button.violet {\n    background-color: white;\n    color: var(--violet-11);\n    box-shadow: 0 2px 10px var(--black-a7);\n}\n.Button.violet:hover {\n    background-color: var(--mauve-3);\n}\n.Button.violet:focus {\n    box-shadow: 0 0 0 2px black;\n}\n.Button.red {\n    background-color: var(--red-4);\n    color: var(--red-11);\n}\n.Button.red:hover {\n    background-color: var(--red-5);\n}\n.Button.red:focus {\n    box-shadow: 0 0 0 2px var(--red-7);\n}\n.Button.mauve {\n    background-color: var(--mauve-4);\n    color: var(--mauve-11);\n}\n.Button.mauve:hover {\n    background-color: var(--mauve-5);\n}\n.Button.mauve:focus {\n    box-shadow: 0 0 0 2px var(--mauve-7);\n}\n\n@keyframes overlayShow {\n    from {\n        opacity: 0;\n    }\n    to {\n        opacity: 1;\n    }\n}\n\n@keyframes contentShow {\n    from {\n        opacity: 0;\n        transform: translate(-50%, -48%) scale(0.96);\n    }\n    to {\n        opacity: 1;\n        transform: translate(-50%, -50%) scale(1);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
